import { Component, input } from '@angular/core';
import { TableItemActionComponent } from '../table-item-action/table-item-action.component';
import { OnlyVisibleTableItemActionsPipe } from '../../pipes/only-visible-table-item-actions.pipe';
import { TableItemAction } from '../../models/table-item-action';
import { Nillable } from '@web/utils';

@Component({
  selector: 'app-table-item-actions',
  imports: [
    TableItemActionComponent,
    OnlyVisibleTableItemActionsPipe,
    OnlyVisibleTableItemActionsPipe,
    TableItemActionComponent,
  ],
  templateUrl: './table-item-actions.component.html',
  styleUrls: ['./table-item-actions.component.scss'],
})
export class TableItemActionsComponent<Item, ItemAction> {
  public readonly model = input.required<Item>();
  /* prettier-ignore */
  public readonly itemActions = input.required<Nillable<TableItemAction<Item, ItemAction>[]>>();
}
